import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { LuWrench, LuShield, LuGraduationCap, LuSearch, LuLightbulb } from "react-icons/lu";
import './ServicesSection.css';

const ServicesSection = () => {
    return (
        <section className="services-section py-5">
            <Container>
                {/* Заголовок секции */}
                <Row className="mb-4">
                    <Col className="text-center">
                        <h2 className="section-title">Наши услуги</h2>
                    </Col>
                </Row>
                
                {/* Описание секции */}
                <Row className="mb-5">
                    <Col className="text-center">
                        <p className="section-description">
                            Компания оказывает полный комплекс услуг по созданию доступной среды
                        </p>
                    </Col>
                </Row>
                
                {/* Верхние строки - 3 услуги */}
                <Row>
                    <Col lg={4} md={4} sm={12} className="mb-4">
                        <div className="service-card d-flex flex-column h-100">
                            <div className="service-content">
                                <h3 className="service-title">
                                    <span className="text-primary">Монтаж</span> оборудования
                                </h3>
                                <p className="service-description">
                                    Профессиональная установка и настройка оборудования для создания доступной среды
                                </p>
                            </div>
                            <div className="service-icon-wrapper">
                                <LuWrench className="service-icon" />
                            </div>
                        </div>
                    </Col>
                    
                    <Col lg={4} md={4} sm={12} className="mb-4">
                        <div className="service-card d-flex flex-column h-100">
                            <div className="service-content">
                                <h3 className="service-title">
                                    Гарантийное <span className="text-primary">обслуживание</span>
                                </h3>
                                <p className="service-description">
                                    Полное гарантийное обслуживание в соответствии с договором
                                </p>
                            </div>
                            <div className="service-icon-wrapper">
                                <LuShield className="service-icon" />
                            </div>
                        </div>
                    </Col>
                    
                    <Col lg={4} md={4} sm={12} className="mb-4">
                        <div className="service-card d-flex flex-column h-100">
                            <div className="service-content">
                                <h3 className="service-title">
                                    <span className="text-primary">Обучение</span> персонала
                                </h3>
                                <p className="service-description">
                                    Комплексное обучение работе с установленным оборудованием
                                </p>
                            </div>
                            <div className="service-icon-wrapper">
                                <LuGraduationCap className="service-icon" />
                            </div>
                        </div>
                    </Col>
                </Row>
                
                {/* Нижние строки - 2 сервиса */}
                <Row className="justify-content-center">
                    <Col lg={4} md={4} sm={12} className="mb-4">
                        <div className="service-card d-flex flex-column h-100">
                            <div className="service-content">
                                <h3 className="service-title">
                                    <span className="text-primary">Обследование</span> объекта
                                </h3>
                                <p className="service-description">
                                    Проведение обследования объекта и разработка рекомендаций по оборудованию
                                </p>
                            </div>
                            <div className="service-icon-wrapper">
                                <LuSearch className="service-icon" />
                            </div>
                        </div>
                    </Col>
                    
                    <Col lg={4} md={4} sm={12} className="mb-4">
                        <div className="service-card d-flex flex-column h-100">
                            <div className="service-content">
                                <h3 className="service-title">
                                    <span className="text-primary">Разработка</span> решений
                                </h3>
                                <p className="service-description">
                                    Создание индивидуального комплекса мероприятий по дооборудованию объекта
                                </p>
                            </div>
                            <div className="service-icon-wrapper">
                                <LuLightbulb className="service-icon" />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default ServicesSection;